module.exports = __webpack_public_path__ + "static/3-62584d815d696ee5d497fe1c6f67111c.jpg";